import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import {
    BridgeIntegration,
    CreateIntegrationRequest,
    UpdateIntegrationRequest
} from "../../../models/bridge/bridge-integration.model";
import { BridgeBaseService } from "./bridge-base.service";

/**
 * Service for 4Bridge Integrations API
 */
@Injectable({
    providedIn: 'root'
})
export class BridgeIntegrationService extends BridgeBaseService<BridgeIntegration> {

    constructor(httpClient: HttpClient) {
        super(httpClient, 'integrations');
    }

    /**
     * Create a new integration
     */
    public createIntegration(request: CreateIntegrationRequest): Observable<BridgeIntegration> {
        return this.create(request as any);
    }

    /**
     * Update an existing integration
     */
    public updateIntegration(id: string, request: UpdateIntegrationRequest): Observable<BridgeIntegration> {
        return this.update(id, request as any);
    }

    /**
     * Trigger a sync for an integration
     */
    public triggerSync(id: string): Observable<any> {
        return this.httpClient
            .post(`${this.baseUrl}/${this.endpoint}/${id}/sync`, {})
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Enable an integration
     */
    public enable(id: string): Observable<BridgeIntegration> {
        return this.httpClient
            .put<BridgeIntegration>(`${this.baseUrl}/${this.endpoint}/${id}`, { isEnabled: true })
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Disable an integration
     */
    public disable(id: string): Observable<BridgeIntegration> {
        return this.httpClient
            .put<BridgeIntegration>(`${this.baseUrl}/${this.endpoint}/${id}`, { isEnabled: false })
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Get integrations by connection ID
     */
    public getByConnectionId(connectionId: string): Observable<BridgeIntegration[]> {
        return this.httpClient
            .get<BridgeIntegration[]>(`${this.baseUrl}/${this.endpoint}?connectionId=${connectionId}`)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }
}
